export class faqAccordion {
  constructor() {
    this.handleToggle();
  }

  handleToggle() {
    const faqItems = document.querySelectorAll('.faq__item');

    faqItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        let content = e.currentTarget;

        if (content.classList.contains('open')) {
          content.classList.remove('open');
          return;
        }

        const open = document.querySelectorAll('.faq__item.open');

        open.forEach((item) => {
          item.classList.remove('open');
        });

        content.classList.toggle('open');
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/faqAccordion.js